import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Shield, Clock, Award, ThumbsUp, RefreshCw, BadgeCheck, Headphones, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

const GuaranteeSection = () => {
  const navigate = useNavigate();

  return (
    <section className="py-10 md:py-16 bg-gradient-to-br from-[#006D77] to-[#0A9396] relative overflow-hidden">
      {/* Dekoratif elementler */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/2"></div>
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full translate-y-1/2 -translate-x-1/2"></div>
      
      <div className="max-w-6xl mx-auto px-4 relative z-10">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
          {/* Sol - İçerik */}
          <div className="w-full md:w-1/2 text-center md:text-left">
            <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm rounded-full px-4 py-2 mb-4">
              <Shield className="w-4 h-4 text-white" />
              <span className="text-white text-sm font-semibold">HizmetGeliyo Garantisi</span>
            </div>
            
            <h2 className="text-2xl md:text-4xl font-bold text-white mb-4 leading-tight">
              Hizmetiniz Güvende,<br />
              <span className="text-[#F6AD55]">Memnuniyetiniz Garantimiz</span>
            </h2>
            
            <p className="text-white/80 mb-6 leading-relaxed">
              Her hizmet 30 gün garantili. Sorun yaşarsanız ücretsiz onarım, 
              memnun kalmazsanız paranız iade. Çünkü sizin memnuniyetiniz bizim önceliğimiz.
            </p>

            {/* Garanti Özellikleri */}
            <div className="grid grid-cols-2 gap-3 mb-6">
              <div className="flex items-center gap-2 bg-white/10 rounded-xl px-3 py-2">
                <CheckCircle className="w-4 h-4 text-green-400" />
                <span className="text-white text-sm">30 Gün Garanti</span>
              </div>
              <div className="flex items-center gap-2 bg-white/10 rounded-xl px-3 py-2">
                <RefreshCw className="w-4 h-4 text-blue-400" />
                <span className="text-white text-sm">Para İade</span>
              </div>
              <div className="flex items-center gap-2 bg-white/10 rounded-xl px-3 py-2">
                <BadgeCheck className="w-4 h-4 text-purple-400" />
                <span className="text-white text-sm">Onaylı Ustalar</span>
              </div>
              <div className="flex items-center gap-2 bg-white/10 rounded-xl px-3 py-2">
                <Headphones className="w-4 h-4 text-orange-400" />
                <span className="text-white text-sm">7/24 Destek</span>
              </div>
            </div>

            <Button
              onClick={() => navigate('/garanti')}
              className="bg-white text-[#006D77] hover:bg-gray-100 px-6 py-3 rounded-full font-semibold shadow-lg hover:shadow-xl transition-all"
            >
              Garanti Detayları
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </div>

          {/* Sağ - İstatistik Kartları */}
          <div className="w-full md:w-1/2">
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-5 border border-white/20 text-center">
                <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
                  <ThumbsUp className="w-6 h-6 text-white" />
                </div>
                <div className="text-3xl font-bold text-white mb-1">%99</div>
                <div className="text-white/70 text-sm">Memnuniyet</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-5 border border-white/20 text-center">
                <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
                  <Shield className="w-6 h-6 text-white" />
                </div>
                <div className="text-3xl font-bold text-white mb-1">30</div>
                <div className="text-white/70 text-sm">Gün Garanti</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-5 border border-white/20 text-center">
                <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
                  <Clock className="w-6 h-6 text-white" />
                </div>
                <div className="text-3xl font-bold text-white mb-1">24s</div>
                <div className="text-white/70 text-sm">Çözüm Süresi</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-5 border border-white/20 text-center">
                <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
                  <Award className="w-6 h-6 text-white" />
                </div>
                <div className="text-3xl font-bold text-white mb-1">10K+</div>
                <div className="text-white/70 text-sm">Çözülen Talep</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GuaranteeSection;
